var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfilo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4664",
    "data-name": "Rettangolo 4664",
    width: 24.266,
    height: 28.033,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8512",
    "data-name": "Raggruppa 8512",
    transform: "translate(740 12456)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8508",
    "data-name": "Raggruppa 8508",
    transform: "translate(190 389)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_4662",
    "data-name": "Rettangolo 4662",
    width: 50,
    height: 50,
    rx: 14,
    transform: "translate(-930 -12845)",
    fill: "#144379"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8505",
    "data-name": "Raggruppa 8505",
    transform: "translate(-727.133 -12445)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_8504",
    "data-name": "Raggruppa 8504",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11378",
    "data-name": "Tracciato 11378",
    d: "M21.085,263.448H3.176A3.185,3.185,0,0,1,0,260.272v-1.4a12.161,12.161,0,0,1,3.975-9,3.157,3.157,0,0,1,3.827-.318,7.982,7.982,0,0,0,4.331,1.232,7.982,7.982,0,0,0,4.331-1.232,3.157,3.157,0,0,1,3.827.318,12.141,12.141,0,0,1,3.975,9v1.4a3.183,3.183,0,0,1-3.181,3.176m-14.991-13.3a2.052,2.052,0,0,0-1.385.537,11.079,11.079,0,0,0-3.619,8.191v1.4a2.087,2.087,0,0,0,2.081,2.081H21.08a2.08,2.08,0,0,0,2.081-2.081v-1.4a11.088,11.088,0,0,0-3.619-8.191,2.061,2.061,0,0,0-2.5-.208,9.063,9.063,0,0,1-4.922,1.407A9.063,9.063,0,0,1,7.2,250.472,2.015,2.015,0,0,0,6.094,250.143Z",
    transform: "translate(0 -235.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_11379",
    "data-name": "Tracciato 11379",
    d: "M99.663,14.126a7.063,7.063,0,1,1,7.063-7.063,7.073,7.073,0,0,1-7.063,7.063m0-13.026a5.968,5.968,0,1,0,5.968,5.968A5.968,5.968,0,0,0,99.663,1.1",
    transform: "translate(-87.53 0)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilo);
export default __webpack_public_path__ + "static/media/profilo.f07b54194c8d52945edf53532e58d740.svg";
export { ForwardRef as ReactComponent };